// extracted by mini-css-extract-plugin
export var avatarContainer = "_57-1";
export var largeAvatarContainer = "_57-2";
export var smallAvatarContainer = "_57-0";